type ChartTooltipRow = {
  label: string;
  value: string;
  /** Swatch colour, matching the series' colour in the chart. */
  color?: string;
};

/**
 * The one hover-tooltip treatment the analytics charts share.
 *
 * Exported as class strings rather than kept private to this component because
 * the Sankey's tooltip cannot use `ChartTooltip` itself — it tracks the cursor
 * over raw SVG and positions itself, where nivo places whatever its `tooltip`
 * prop returns. Sharing the strings is what stops the two drifting apart,
 * which is how the page ended up with three different-looking tooltips.
 */
export const TOOLTIP_SURFACE =
  "pointer-events-none whitespace-nowrap rounded-md bg-content-1000 px-2.5 py-1.5 text-xs font-medium text-content-1000-inverted";

export const TOOLTIP_TITLE = "font-bold";

/** The headline number. Part of the heading, so full white like the title. */
export const TOOLTIP_SUBTITLE = "my-0.5 font-bold";

/**
 * Secondary text — series names, percentages.
 *
 * Not `text-content-100-inverted`: that token is 50% white, which greys out
 * against the full-white values beside it and reads as disabled. 78% is the
 * value the reference dashboard uses.
 */
export const TOOLTIP_LABEL = "text-[rgba(255,255,255,0.78)]";

const TOOLTIP_VALUE = "ml-auto pl-4 font-bold text-content-1000-inverted";

export const ChartTooltip = ({
  title,
  subtitle,
  rows
}: {
  title: string;
  subtitle?: string;
  rows: ChartTooltipRow[];
}) => (
  <div className={TOOLTIP_SURFACE}>
    <p className={TOOLTIP_TITLE}>{title}</p>
    {subtitle ? <p className={TOOLTIP_SUBTITLE}>{subtitle}</p> : null}
    {rows.map((row) => (
      <p
        key={row.label}
        className={`flex items-center gap-1.5 ${TOOLTIP_LABEL}`}
      >
        {row.color ? (
          <span
            className="inline-block h-2 w-2 shrink-0 rounded-full"
            style={{ backgroundColor: row.color }}
          />
        ) : null}
        <span>{row.label}</span>
        <b className={TOOLTIP_VALUE}>{row.value}</b>
      </p>
    ))}
  </div>
);
